import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'z-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  constructor() {}
}
